import React from 'react';
import './OpeningHours.scss'; // Optional CSS file

const OpeningHoursCard = ({ openingHours }) => {
  // Sort days in correct order
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const sortedHours = [...openingHours].sort((a, b) => {
    return dayOrder.indexOf(a.day_of_week) - dayOrder.indexOf(b.day_of_week);
  });

  // Format time from "09:00:00" to "9:00 AM"
  const formatTime = (timeString) => {
    if (!timeString || timeString === '00:00:00') return 'Closed';

    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12;

    return `${formattedHour}:${minutes} ${ampm}`;
  };

  // Check if currently open
  const isCurrentlyOpen = () => {
    const now = new Date();
    const currentDay = now.toLocaleDateString('en-GB', { weekday: 'long' });
    const currentTime = now.getHours() * 100 + now.getMinutes(); // Convert to HHMM format

    const todayHours = openingHours.find(hours => hours.day_of_week === currentDay);

    if (!todayHours || todayHours.is_closed) return false;

    const openTime = parseInt(todayHours.open_time.replace(/:/g, '').substring(0, 4));
    const closeTime = parseInt(todayHours.close_time.replace(/:/g, '').substring(0, 4));

    return currentTime >= openTime && currentTime <= closeTime;
  };

  const currentlyOpen = isCurrentlyOpen();

  return (
    <>
      <h2 className="mb-2 poppin text-center mt-5 mb-5">Opening Hours</h2>
      <div className="opening-hours-card">
        <div className="card-header">
          <div className={`status-badge ${currentlyOpen ? 'open' : 'closed'}`}>
            <span className="status-dot"></span>
            {currentlyOpen ? 'Open Now' : 'Closed Now'}
          </div>
        </div>

        <div className="hours-list">
          {sortedHours.map((hours) => {
            const isToday = new Date().toLocaleDateString('en-US', { weekday: 'long' }) === hours.day_of_week;

            return (
              <div
                key={hours.id}
                className={`hours-item ${isToday ? 'today' : ''} ${hours.is_closed ? 'closed' : ''}`}
              >
                <div className="day-column">
                  <span className="day-name poppin">{hours.day_of_week}</span>
                  {isToday && <span className="today-badge poppin">Today</span>}
                </div>

                <div className="hours-column">
                  {hours.is_closed ? (
                    <span className="closed-text">Closed</span>
                  ) : (
                    <>
                      <span className="open-time poppin">{formatTime(hours.open_time)}</span>
                      <span className="time-separator"> – </span>
                      <span className="close-time poppin">{formatTime(hours.close_time)}</span>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="card-footer">
          <small className="text-muted">
            <i className="fas fa-info-circle me-1 poppin"></i>
            Times may vary on public holidays
          </small>
        </div>
      </div>
    </>
  );
};

export default OpeningHoursCard;